exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-263ecdc0] .el-drawer__body{padding:10px 20px 50px 20px}.p10[data-v-263ecdc0]{width:100%;padding:0 10px}\n", ""]);

// exports
